var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalizations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0383 5.24951C10.7242 5.24951 7.27892 5.96045 4.41877 7.68858C-1.6242 11.3362 -0.913263 19.3097 3.21017 24.1659C4.79064 26.0253 8.65705 29.5417 11.4133 28.0433C13.3383 26.9987 12.5289 25.4948 12.1953 24.3737C11.9985 23.7011 12.5016 23.0284 13.2016 23.0339C13.207 23.0339 13.2125 23.0339 13.218 23.0339C20.9289 23.0339 27.9945 19.0089 27.9945 14.1144C27.9945 9.21983 21.7492 5.24951 14.0383 5.24951Z",
    fill: "#D28E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21797 23.0834C7.50764 23.0834 8.55312 22.0379 8.55312 20.7482C8.55312 19.4586 7.50764 18.4131 6.21797 18.4131C4.9283 18.4131 3.88281 19.4586 3.88281 20.7482C3.88281 22.0379 4.9283 23.0834 6.21797 23.0834Z",
    fill: "#FFCC4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94923 16.2035C6.2389 16.2035 7.28438 15.158 7.28438 13.8684C7.28438 12.5787 6.2389 11.5332 4.94923 11.5332C3.65956 11.5332 2.61407 12.5787 2.61407 13.8684C2.61407 15.158 3.65956 16.2035 4.94923 16.2035Z",
    fill: "#43C6B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5063 12.6708C12.796 12.6708 13.8414 11.6253 13.8414 10.3356C13.8414 9.04597 12.796 8.00049 11.5063 8.00049C10.2166 8.00049 9.17113 9.04597 9.17113 10.3356C9.17113 11.6253 10.2166 12.6708 11.5063 12.6708Z",
    fill: "#E16464"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8016 12.1186C20.0912 12.1186 21.1367 11.0731 21.1367 9.7834C21.1367 8.49373 20.0912 7.44824 18.8016 7.44824C17.5119 7.44824 16.4664 8.49373 16.4664 9.7834C16.4664 11.0731 17.5119 12.1186 18.8016 12.1186Z",
    fill: "#50C4DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5047 8.80986L21.5742 8.00049L19.6492 8.81533C19.6492 8.81533 19.4742 11.7083 20.5789 14.6396L21.5742 15.9028L22.5695 14.6396C23.6797 11.7028 23.5047 8.80986 23.5047 8.80986Z",
    fill: "#E7EEF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.575 14.6338C24.1172 18.5439 23.543 27.9721 21.5797 27.9721C19.6164 27.9721 19.0422 18.5439 20.5844 14.6338H22.575Z",
    fill: "#50C4DF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6633 3.38474C22.843 2.54802 22.4055 1.72224 22.1648 1.08239C21.9461 0.491767 21.2844 0.311298 20.8414 0.726923C19.8789 1.62927 18.5719 3.31911 18.4406 5.94958C18.3805 7.08708 18.7797 7.90192 19.3047 8.48161C20.4586 9.7613 22.3125 9.85427 23.5867 8.70036C24.1664 8.17536 24.6476 7.40427 24.7078 6.26677C24.7078 6.2613 24.7078 6.25036 24.7078 6.24489C24.7625 5.16208 24.3742 4.11208 23.6633 3.38474Z",
    fill: "#3A484A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizations);
export default __webpack_public_path__ + "static/media/personalizations.dda4a685d7956c0022aaad8f44e210fa.svg";
export { ForwardRef as ReactComponent };